var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloppyDiskRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C8.42857 10 7.14286 11.2857 7.14286 12.8571C7.14286 14.4286 8.42857 15.7143 10 15.7143C11.5714 15.7143 12.8571 14.4286 12.8571 12.8571C12.8571 11.2857 11.5714 10 10 10ZM19.3348 4.33482L15.5893 0.589286C15.2277 0.225893 14.6786 0 14.1116 0H2.85714C1.27902 0 0 1.27902 0 2.85714V17.1429C0 18.721 1.27902 20 2.85714 20H17.1429C18.721 20 20 18.721 20 17.1429V5.88839C20 5.32143 19.7723 4.77232 19.3348 4.33482ZM5.71429 2.14286H12.1429V5.71429H5.71429V2.14286ZM17.8571 17.1429C17.8571 17.5373 17.5373 17.8571 17.1429 17.8571H2.85714C2.46268 17.8571 2.14286 17.5373 2.14286 17.1429V2.85714C2.14286 2.46259 2.46268 2.14286 2.85714 2.14286H3.57143V6.78571C3.57143 7.37723 4.05134 7.85714 4.64286 7.85714H13.2143C13.808 7.85714 14.2857 7.37946 14.2857 6.78571V2.31607L17.779 5.80938C17.8304 5.85714 17.8571 5.92857 17.8571 5.99554V17.1429Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDiskRegular);
export default __webpack_public_path__ + "static/media/floppy-disk-regular.d0a925f77e74e31c6e2c94a49b393884.svg";
export { ForwardRef as ReactComponent };